import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { useNavigate } from "react-router-dom";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};
const getServices = async () => {
  const res = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/service?type=commercial`
  );
  return res.data.data;
};

const Commercial = (props) => {
  const navigate = useNavigate();
  const [service, setService] = useState([]);
  useEffect(() => {
    getServices().then((res) => {
      setService(res);
    });
  }, []);
  return (
    <div className="wpo-service-wrap wpo-service-slide">
      <div className="row">
        {service && service.length > 0 ? (
          service.slice(0, 6).map((service, srv) => (
            <div
              className="col-lg-4 col-md-6 col-12"
              key={srv}
              onClick={() => {
                ClickHandler();
                navigate(`/service-single/${service.id}`);
              }}
            >
              <div
                className="wpo-service-item"
                style={{
                  height: "400px",
                  overflow: "hidden",
                  paddingBottom: "20px",
                }}
              >
                <div className="wpo-service-icon">
                  <div className="icon">
                    <img src={service.image} alt="" />
                  </div>
                </div>
                <div className="wpo-service-text">
                  <h2>
                    <Link
                      onClick={ClickHandler}
                      to={`/service-single/${service.Id}`}
                    >
                      {service.name}
                    </Link>
                  </h2>
                  <p
                    dangerouslySetInnerHTML={{ __html: service.description }}
                    style={{
                      overflow: "hidden",
                      height: "200px",
                      textOverflow: "ellipsis",
                    }}
                  ></p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center">No services found</p>
        )}
      </div>
    </div>
  );
};

export default Commercial;
